import { Button, Card } from 'components/ds';
import React from 'react';
import { styled } from 'styled-components';

export const ResponsiveWidth=752;
export const ResponsiveHeight=560;

export const FormWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  //height: calc(100% + 4 * var(--spacing-regular));
`;

export const TitleContainer = styled.div`
  color: var(--color-neutral-dark);
  font-size: var(--font-giant);
    font-weight: semi-bold;
  margin-bottom: var(--spacing-regular)
`;
export const DescriptionContainer = styled.div`
color: var(--colorTextBgContainer);
text-align:center;
    margin-bottom: var(--spacing-regular);
`;

export const FooterDiv = styled.div`
  width: calc(100%);
  padding-bottom: var(--spacing-regular);

    @media (max-width: 1280px) {
      padding-bottom: 0px;
    }
`;

export const ButtonSmall = styled((props: any) => <Button {...props} />)``;

export const ButtonMedium = styled((props: any) => <Button {...props} />)``;

export const ButtonLarge = styled((props: any) => (
  <Button
    {...props}
    type={props.type || 'highlight'}
    size="large"
    style={{
      width: '100%'
    }}
  />
))`
    @media (max-width: 1280px) {
       font-size: var(--font-paragraph) !important;
       padding-left: var(--spacing-regular) !important;
       padding-right: var(--spacing-regular) !important;
       height: var(--form-item-height) !important;
    }
`;

export const ButtonLargeDefaultShadow = styled((props: any) => (
  <Button
    {...props}
    type="default"
    size="large"
    style={{
      width: '100%',
      border: '1px solid rgba(0, 0, 0, 0.05)',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
    }}
  />
))``;

export const ButtonBack = styled((props: any) => <Button {...props} />)``;

export const TextTitle = styled.div`
  font-weight: bold;
`;
export const TextBig = styled.div`
font-weight: bold;
`;

export const PanelCard = styled(Card)`
  margin: 5px;
  .ant-card-body {
    padding: 16px;
  }
`;
